const ROUTE_ACTIONS = {
  ROUTE_CHANGED: 'ROUTE_CHANGED',
  ROUTES_LOADED: 'ROUTES_LOADED',
  ADD_SCREEN_DESIGNER_ROUTE_PARAMS: 'ADD_SCREEN_DESIGNER_ROUTE_PARAMS',
  ADD_CUSTOM_ROUTE_PARAMS: 'ADD_CUSTOM_ROUTE_PARAMS',
  CLEAR_CUSTOM_ROUTE_PARAMS: 'CLEAR_CUSTOM_ROUTE_PARAMS',
  CLEAR_SCREEN_DESIGNER_ROUTE_PARAMS: 'CLEAR_SCREEN_DESIGNER_ROUTE_PARAMS'
};

const routeChangedAction = data => {
  return {
    type: ROUTE_ACTIONS.ROUTE_CHANGED,
    payload: data
  };
};

const addScreenDesignerRouteParams = params => {
  return {
    type: ROUTE_ACTIONS.ADD_SCREEN_DESIGNER_ROUTE_PARAMS,
    payload: params
  };
};

const removeScreenDesignerRouteParams = () => {
  return {
    type: ROUTE_ACTIONS.CLEAR_SCREEN_DESIGNER_ROUTE_PARAMS,
    payload: {}
  };
};

const addCustomRouteParams = params => {
  return {
    type: ROUTE_ACTIONS.ADD_CUSTOM_ROUTE_PARAMS,
    payload: params
  };
};

const removeCustomRouteParams = () => {
  return {
    type: ROUTE_ACTIONS.CLEAR_CUSTOM_ROUTE_PARAMS,
    payload: {}
  };
};

const routesLoadedAction = routes => {
  return {
    type: ROUTE_ACTIONS.ROUTES_LOADED,
    payload: routes
  };
};

export {
  ROUTE_ACTIONS,
  routeChangedAction,
  routesLoadedAction,
  addScreenDesignerRouteParams,
  removeScreenDesignerRouteParams,
  addCustomRouteParams,
  removeCustomRouteParams
};
